import type { FC } from 'react';
import type { OpenInterestProps } from './types';
import OpenInterestWidget from './open-interest-widget';
import { OpenInterestProvider } from '../../../../providers/widgets/open-interest-provider/open-interest-provider';

const OpenInterestWrapperProvider: FC<OpenInterestProps> = (props) => (
  <OpenInterestProvider providerKey={props.providerKey}>
    <OpenInterestWidget {...props} />
  </OpenInterestProvider>
);

export default OpenInterestWrapperProvider;
